import { render, staticRenderFns } from "./InstructionsModal.vue?vue&type=template&id=3d5f5a90&scoped=true"
import script from "./InstructionsModal.vue?vue&type=script&lang=js"
export * from "./InstructionsModal.vue?vue&type=script&lang=js"
import style0 from "./InstructionsModal.vue?vue&type=style&index=0&id=3d5f5a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f5a90",
  null
  
)

export default component.exports